import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

const estadoLabels = {
  agendado: 'Agendado',
  en_espera_asignacion: 'En Espera de Asignación',
  asignado: 'Asignado',
  realizada: 'Realizada',
  suspendida: 'Suspendida',
  aprobado: 'Aprobado',
  rechazado: 'Rechazado',
};

const buildRows = (mov) => [
  ['Estado', estadoLabels[mov.estado] || mov.estado],
  ['Área', mov.area],
  ['Personas', mov.num_personas],
  ['Salida', format(parseISO(mov.fecha_inicio), "d MMM yyyy, HH:mm", { locale: es })],
  ['Finalización', format(parseISO(mov.fecha_fin), "d MMM yyyy, HH:mm", { locale: es })],
  ['Sitio de Salida', mov.direccion],
  ['Lugar de Llegada', mov.direccion_llegada || '-'],
  ['Referencia', mov.referencia],
  ['Responsable', mov.responsable],
  ['Contacto', mov.telefono_contacto],
  ['Solicitante', mov.usuario_email],
  ...(mov.vehiculo ? [['Vehículo', mov.vehiculo]] : []),
  ...(mov.conductor ? [['Conductor', mov.conductor]] : []),
  ...(mov.telefono_conductor ? [['Tel. Conductor', mov.telefono_conductor]] : []),
  ...(mov.comentario_admin ? [['Comentario', mov.comentario_admin]] : []),
];

export const CalendarMovDetailDialog = ({ selectedMov, onClose }) => (
  <Dialog open={!!selectedMov} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-w-lg bg-white border border-[#E9ECEF]">
      {selectedMov && (
        <>
          <DialogHeader>
            <DialogTitle className="text-xl font-black font-['Chivo'] tracking-tight text-[#0A0A0A]">
              Detalle de Movilización
            </DialogTitle>
            <DialogDescription className="text-[#495057] font-['IBM_Plex_Sans']">
              ID: {selectedMov.id ? selectedMov.id.slice(0, 8) : 'N/A'}
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-3 mt-4 text-sm font-['IBM_Plex_Sans']">
            {buildRows(selectedMov).map(([label, value]) => (
              <div key={label} className="flex gap-3 py-2 border-b border-[#E9ECEF]">
                <span className="text-[#6C757D] w-32 flex-shrink-0">{label}</span>
                <span className="text-[#0A0A0A] font-medium flex-1">{value}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);
